import { Button, Form, Modal } from "antd";
import DiscountCodeSelect from "components/data/DiscountCodeSelect";
import { FormattedMessage } from "react-intl";

import { DiscountCodePickerModalProps } from "./types";

const DiscountCodePickerModal: React.FC<DiscountCodePickerModalProps> = ({
  onFinish,
  ...props
}) => (
  <Modal
    title={<FormattedMessage defaultMessage="Add Existing Discount Code" />}
    footer={null}
    {...props}
  >
    <Form {...{ onFinish }}>
      <Form.Item name="discountCode">
        <DiscountCodeSelect />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          <FormattedMessage defaultMessage="Submit" />
        </Button>
      </Form.Item>
    </Form>
  </Modal>
);

export default DiscountCodePickerModal;
